import { Component } from '@verndale/core';
import { DESKTOP, TABLET } from '../utils/breakpoints';
import { rovingIndex } from '@verndale/roving-ux';

class Module extends Component {
  setupDefaults() {
    const self = this;

    this.dom = {
      $tabContainer: this.el.querySelector('.vertical-tab__tablist'),
      $tabs: Array.from(this.el.querySelectorAll('[role="tab"]')),
      $tablist: this.el.querySelector('[role="tablist"]'),
      $tabContent: this.el.querySelectorAll('.vertical-tab__content'),
      $tabCta: this.el.querySelectorAll('.vertical-tab__content-cta'),
      $tabToggleSvg: this.el.querySelectorAll('.vertical-tab__toggle-svg'),
      $tabToggle: Array.from(this.el.querySelectorAll('.vertical-tab__toggle-btn')),
      $animatedBox: this.el.querySelector('.vertical-tab__box-animator')
    };

    this.index = 0;
    this.accordion = false;
    this.setDirection();
    if (!this.accordion) {
      this.activateTab(this.dom.$tabs[0], false);
    }

    this.accordionSetMarginDesktop();

    rovingIndex({
      element: self.el,
      target: '.vertical-tab__tab-btn'
    });
  }

  addListeners() {
    window.addEventListener('resize', this.handleResize.bind(this));
    window.addEventListener('resize', this.accordionSetMarginDesktop.bind(this));
    this.dom.$tablist.addEventListener('click', (e) => this.handleClick(e));
  }

  accordionSetMarginDesktop() {
    if (window.matchMedia(`(min-width: ${TABLET}px)`).matches) {
      this.partial = Math.ceil(this.dom.$tabContent.length / 3);
      this.partialContainerHeight = this.dom.$tabContainer.offsetHeight / 3;
      let marginBlockStart = 0;
      this.dom.$tabContent.forEach((content, index) => {
        if (index % this.partial === 0 && index > (this.partial - 1)) {
          marginBlockStart += this.partialContainerHeight
        }

        if (index <= (this.partial - 1)) {
          content.style.marginBlockStart = '40px';
        } else {
          content.style.marginBlockStart = `${marginBlockStart}px`;
        }
      });
    } else {
      this.dom.$tabContent.forEach((content, index) => {
        content.style.marginBlockStart = null;
      });
    }
  }

  animatorBox(index) {
    const i = parseInt(index);

    if (window.matchMedia(`(min-width: ${TABLET}px)`).matches) {
      if (i <= (this.partial - 1)) {
        this.dom.$animatedBox.removeAttribute('style');
      } else {
        const marginBase = Math.ceil((i + 1)/this.partial);
        this.dom.$animatedBox.style.marginBlockStart = `${this.partialContainerHeight * (marginBase - 1)}px`;
      }
    }
  }

  deactivateTabs() {
    this.dom.$tabs.forEach((tab) => {
      const index = tab.getAttribute('data-index');

      tab.setAttribute('tabindex', '-1');
      tab.setAttribute('aria-selected', 'false');
      tab.classList.remove('vertical-tab__tab-btn--selected');

      this.dom.$tabContent[index].classList.remove('vertical-tab__content--selected');
      this.accordion ? (this.dom.$tabContent[index].style.blockSize = '0px') : (this.dom.$tabContent[index].style.blockSize = 'auto');
      this.dom.$tabContent[index].setAttribute('tabindex', '-1');

      if (index > 0) {
        this.dom.$tabToggle[index].setAttribute('tabindex', '-1');
      } else {
        this.dom.$tabToggle[index].removeAttribute('tabindex');
      }
    });

    this.dom.$tabCta.forEach((cta) => {
      cta.setAttribute('tabindex', '-1');
    });
  }

  activateTab(tab, setFocus = true) {
    if (tab.getAttribute('data-index')) {
      this.index = tab.getAttribute('data-index');

      this.deactivateTabs();
      tab.removeAttribute('tabindex');
      tab.setAttribute('aria-selected', 'true');
      tab.classList.add('vertical-tab__tab-btn--selected');
      this.dom.$tabContent[this.index].classList.add('vertical-tab__content--selected');

      this.dom.$tabContent[this.index].setAttribute('tabindex', '0');

      this.dom.$tabContent[this.index].style.blockSize = 'auto';

      this.animatorBox(this.index);

      if (this.dom.$tabContent[this.index].querySelector('.vertical-tab__content-cta')) {
        this.dom.$tabContent[this.index].querySelector('.vertical-tab__content-cta').removeAttribute('tabindex');
      }

      if (setFocus) {
        tab.focus();
      }
    }
  }

  toggleTab(toggle, setFocus = false) {
    if (toggle.getAttribute('data-index')) {
      this.index = toggle.getAttribute('data-index');

      if (this.dom.$tabs[this.index].getAttribute('aria-selected') === 'false') {
        let blockSize = this.dom.$tabContent[this.index].children[0].scrollHeight + 30;
        if (this.dom.$tabContent[this.index].querySelector('.vertical-tab__content-cta')) {
          blockSize = blockSize + this.dom.$tabContent[this.index].querySelector('.vertical-tab__content-cta').scrollHeight;
          this.dom.$tabContent[this.index].querySelector('.vertical-tab__content-cta').removeAttribute('tabindex');
        }

        this.dom.$tabs[this.index].setAttribute('aria-selected', 'true');
        this.dom.$tabs[this.index].classList.add('vertical-tab__tab-btn--selected');

        this.dom.$tabContent[this.index].style.blockSize = `${blockSize}px`;
        this.dom.$tabContent[this.index].classList.add('vertical-tab__content--selected');
        this.dom.$tabContent[this.index].setAttribute('tabindex', '0');

        this.dom.$tabToggleSvg[this.index].classList.add('vertical-tab__toggle-svg--open');
      } else {
        this.dom.$tabs[this.index].setAttribute('aria-selected', 'false');
        this.dom.$tabs[this.index].classList.remove('vertical-tab__tab-btn--selected');

        this.dom.$tabContent[this.index].style.blockSize = '0px';
        this.dom.$tabContent[this.index].classList.remove('vertical-tab__content--selected');
        this.dom.$tabContent[this.index].setAttribute('tabindex', '-1');

        if (this.dom.$tabContent[this.index].querySelector('.vertical-tab__content-cta')) {
          this.dom.$tabContent[this.index].querySelector('.vertical-tab__content-cta').setAttribute('tabindex', '-1');
        }

        this.dom.$tabToggleSvg[this.index].classList.remove('vertical-tab__toggle-svg--open');
      }

      if (setFocus) {
        toggle.focus();
      }
    }
  }

  switchButtonToggle() {
    this.dom.$tabs.forEach((tab) => {
      tab.setAttribute('tabindex', '-1');
    });
  }

  handleClick(e) {
    this.accordion ? this.toggleTab(e.target) : this.activateTab(e.target, true);
  }

  setDirection() {
    if (window.matchMedia(`(max-width: ${TABLET - 1}px)`).matches && !this.accordion) {
      this.accordion = true;
      this.deactivateTabs();
      this.switchButtonToggle();
      this.toggleTab(this.dom.$tabToggle[0], false);
      return;
    }

    if (window.matchMedia(`(min-width: ${TABLET}px)`).matches && this.accordion) {
      this.accordion = false;
      this.deactivateTabs();
      this.switchButtonToggle();
      this.activateTab(this.dom.$tabs[0], true);
    }
  }

  handleResize() {
    let timeout = false;
    clearTimeout(timeout);
    timeout = setTimeout(this.setDirection.bind(this), 200);
  }
}

export default Module;
